import React from "react";
import { useDispatch } from "react-redux";

import ChbaCheckbox from "components/Input/ChbaCheckbox";

import { updateChecklistItems } from "features/Model/ProjectPathChecklist/_ducks/actions";

import ParagraphInput from "components/paragraphInput";
import CostInput from "components/ChbaChecklist/CostInput";
import { isEmpty } from "lodash";

const ChbaChecklistItemInput = ({
    component,
    name,
    formTitle = "",
    isDisabled = false,
    input = {},
    onChange = () => {},
    howMuchFilesLeft = 0,
    setOpenComment,
    checkboxValue
}) => {
    const { value: stateValue } = input;

    const dispatch = useDispatch();

    const handleChange = (val) => {
        let checkboxValueToSet
        if (stateValue === false) {
            setOpenComment(false)
            checkboxValueToSet = true;
        } else if (stateValue === true) {
            setOpenComment(true)
            checkboxValueToSet = 'n/a';
        } else if (stateValue === 'n/a') {
            setOpenComment(false)
            checkboxValueToSet = false;
        }
        const value = val.target.id === "checkbox" ? checkboxValueToSet : val.target.value;
        dispatch(updateChecklistItems({ path: name, value }));
        onChange(value);
    };

    const handleCostChange = (value) => {
        dispatch(updateChecklistItems({ path: name, value }));
        // onChange(value);
    };

    return component === "paragraphInput" ? (
        // <input value={value} placeholder="text goes here..." onChange={handleChange} />
        <ParagraphInput value={stateValue} onChange={handleChange} formTitle={formTitle} checkboxValue={checkboxValue} />
    ) : component === "checkbox" ? (
        <ChbaCheckbox
            value={stateValue}
            onChange={handleChange}
            isDisabled={isDisabled}
            howMuchFilesLeft={howMuchFilesLeft}
        />
    ) : component === "costInput" ? (
        <CostInput value={stateValue} onChange={handleCostChange} isDisabled={isDisabled} />
    ) : (
        <span></span>
    );
};

export default ChbaChecklistItemInput;
